import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import Moment from 'moment'
import T from 'prop-types'
import ProfileHelper from 'helpers/profile'

function FilterDate(props) {
  const { activeDate, onDateChange } = props
  const locale = ProfileHelper.getCurrentLocale()

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      <DatePicker
        fullWidth
        autoOk
        disableToolbar
        disableFuture
        variant="inline"
        format="dd/MM/yyyy"
        id="date-picker-inline"
        label="DD-MM-YYYY"
        value={activeDate}
        onChange={onDateChange}
      />
    </MuiPickersUtilsProvider>
  )
}

FilterDate.propTypes = {
  activeDate: T.instanceOf(Moment).isRequired,
  onDateChange: T.func.isRequired,
}

export default FilterDate
